import { fb, validators } from 'form';

export function getProductEditModel(data) {
  const statusList = [{ name: 'Select...', value: '' },
  ...data.productStatuses.map((x) => { return { name: x.text, value: x.value } })];
  const productTypeList = [{ name: 'Select...', value: '' },
  ...data.productTypes.map((x) => { return { name: x.text, value: x.value } })];
  const taxTypeList = [{ name: 'Select...', value: '' },
  ...data.taxTypes.map((x) => { return { name: x.taxName, value: x.taxCode } })];
  const shippingFeeTypeList = [{ name: 'Select...', value: '' },
    ...data.shippingFeeTypes.map((x) => { return { name: x.text, value: x.value } })];
  const categoryList = [
    ...data.categories.map((x) => { return { name: x.categoryName, value: x.categoryId } })];

  console.log('getProductEditModel', data)

  const model = fb.group({
    productId: [data.productId || '', [], { type: 'hidden' }],
    productStatus: [data.productStatus, [validators.Required()], { type: 'select', options: statusList }],
    productCode: [data.productCode || '', [], { type: 'text' }],
    productName: [data.productName || '', [validators.Required()], { type: 'text' }],
    productSubName: [data.productSubName || '', [], { type: 'text' }],
    productSlug: [data.productSlug || '', [validators.Required()], { type: 'text' }],
    productType: [data.productType, [validators.Required()], { type: 'select', options: productTypeList }],
    categoryIds: [data.categoryIds || [], [], { type: 'checkboxList', label:'Category', options: categoryList, style: { inline: true } }],
    taxCode: [data.taxCode, [validators.Required()], { type: 'select', options: taxTypeList }],
    //vendId: [data.vendId || '', [], { type: 'text' }],
    productImages: [data.productImages || [], [], null],
    description: [data.description || '', [], { type: 'html', style: { } }],
    price: [data.price, [validators.Required()], { type: 'number', label: 'Price (AU$)', helpText: '(inc Tax)' }],
    //retailPrice: [data.retailPrice, [], { type: 'number', label: 'Retail Price (AU$)', helpText: 'Use only when you display discount amount (inc Tax)' }],
    shippingFeeType: [data.shippingFeeType, [], { type: 'select', options: shippingFeeTypeList }],
    shippingFee: [data.shippingFee || '', [], { type: 'number', label: 'Shipping Fee (AU$)', helpText: 'Only when you calculate based on each item' }],
    shortDesc: [data.shortDesc || '', [validators.Required()], { type: 'textarea', style: { rows: 7 } }],
    metaDesc: [data.metaDesc || '', [], { type: 'textarea', style: { rows: 7 } }],
    variantOptions: fb.array([])
  })

  // const itemArray = model.find('detailSection').controls;
  // data.detailSection.forEach(item => {
  //   itemArray.push(fb.group({
  //     itemValue: [item.itemValue || '', [], { type: 'html', label: null, style: { } }],
  //     itemStatus: [item.itemStatus, [], { type: 'select', style: { } }],
  //     itemId: [item.itemId],
  //     itemTypeCode: [item.itemTypeCode]
  //   }))
  // })

  // buildArray(data.howToSection, model.find('howToSection').controls);
  // buildArray(data.discoverMoreSection, model.find('discoverMoreSection').controls);
  // buildArray(data.detailSection, model.find('detailSection').controls);
  // buildArray(data.specSection, model.find('specSection').controls);
  // buildArray(data.seeMoreSection, model.find('seeMoreSection').controls);

  return model;
}

// function buildArray(items, itemArray) {
//   items.forEach(item => {
//     itemArray.push(createGroup(item))
//   })
// }

// function getFilters(filters, categoryCode){
//   return filters.filter(x => x.categoryCode === categoryCode)
// }

// function getFilterValues(filterValues, categoryCode){
//   if (!filterValues) return []
//   return filterValues.filter(x => x.indexOf(categoryCode) > 0)
// }

// const specSectionList = [{ name: 'Left', value: 'L' }, { name: 'Right', value: 'R' }];
// const linkTypeList = [{ name: 'Auto', value: 'auto' }, { name: 'Blog', value: 'blog' }, { name: 'Instagram', value: 'instagram' }, { name: 'Web', value: 'web' }];

// export function createGroup(item) {
//   const group = {
//     itemStatus: [item.itemStatus, [], { type: 'select', style: {} }],
//     itemId: [item.itemId],
//     itemTypeCode: [item.itemTypeCode]
//   };

//   const g = fb.group({ ...group, ...createItem(item) })
//   g.customValueFn = getItemValue;
//   return g;
// }

// export function createItem(item) {
//   if (item.itemTypeCode === 'video') {
//     if (!item.itemValue) return null;
//     const video = JSON.parse(item.itemValue);
//     //console.log(video);
//     return {
//       videoUrl: [video.video || '', [], { type: 'text', label: 'Youtube Id or Url' }],
//       title: [video.title || '', [], { type: 'text', label: 'Title' }],
//       desc: [video.desc || '', [], { type: 'html', label: 'Short Description', style: {} }],
//     }
//   }

//   if (item.itemTypeCode === 'spec') {
//     if (!item.itemValue) return null;
//     const spec = JSON.parse(item.itemValue);
//     //console.log(video);
//     return {
//       category: [spec.category || '', [], { type: 'select', label: 'Section', options: specSectionList }],
//       label: [spec.label || '', [], { type: 'text', label: 'Label' }],
//       text: [spec.text || '', [], { type: 'text', label: 'Specification', style: {} }],
//     }
//   }

//   if (item.itemTypeCode === 'html') {
//     return {
//       html: [item.itemValue || '', [], { type: 'html', label: null, style: {} }]
//     }
//   }

//   if (item.itemTypeCode === 'link') {
//     if (!item.itemValue) return null;
//     const link = JSON.parse(item.itemValue);
//     return {
//       linkType: [link.linkType || 'auto', [], { type: 'select', label: 'Type', options: linkTypeList }],
//       title: [link.title || '', [], { type: 'text', label: 'Title' }],
//       url: [link.url || '', [], { type: 'text', label: 'URL', style: {} }]
//     }
//   }

//   if (item.itemTypeCode === 'weblink') {
//     if (!item.itemValue) return null;
//     const link = JSON.parse(item.itemValue);
//     return {
//       //linkType: [link.linkType || 'auto', [], { type: 'select', label: 'Type', options: linkTypeList }],
//       title: [link.title || '', [], { type: 'text', label: 'Title' }],
//       url: [link.url || '', [], { type: 'text', label: 'URL', style: {} }]
//     }
//   }
// }

// function getItemValue(item, fns) {
//   const val = (name) => {
//     const control = item.find(name);
//     return control ? control.value : null;
//   }
//   const value = {
//     itemStatus: val('itemStatus'),
//     itemId: val('itemId'),
//     itemTypeCode: val('itemTypeCode')
//   }

//   if (value.itemTypeCode === 'video') {
//     value.itemValue = JSON.stringify({ video: val('videoUrl'), title: val('title'), desc: val('desc') });
//   } else if (value.itemTypeCode === 'spec') {
//     value.itemValue = JSON.stringify({ category: val('category'), label: val('label'), text: val('text') });
//   } else if (value.itemTypeCode === 'html') {
//     value.itemValue = val('html');
//   } else if (value.itemTypeCode === 'link') {
//     value.itemValue = JSON.stringify({ linkType: val('linkType'), title: val('title'), url: val('url') });
//   } else if (value.itemTypeCode === 'weblink') {
//     value.itemValue = JSON.stringify({ title: val('title'), url: val('url') });
//   }
//   return value;
// }